import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
function cutpicture(imagePath, width, height, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    const seed = Math.floor(Math.random() * 100000000000000)
    const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      1: {
        inputs: {
          image: 'example.png'
        },
        class_type: 'LoadImage',
        _meta: {
          title: 'Load Image'
        }
      },
      2: {
        inputs: {
          upscale_method: 'nearest-exact',
          width: width,
          height: height,
          crop: 'disabled',
          image: [
            '6',
            0
          ]
        },
        class_type: 'ImageScale',
        _meta: {
          title: 'Upscale Image'
        }
      },
      4: {
        inputs: {
          filename_prefix: 'ComfyUI',
          images: [
            '2',
            0
          ]
        },
        class_type: 'SaveImage',
        _meta: {
          title: 'Save Image'
        }
      },
      5: {
        inputs: {
          image_url: imagePath
        },
        class_type: 'AC_从URL加载图像',
        _meta: {
          title: 'AC_从URL加载图像'
        }
      },
      6: {
        inputs: {
          boolean: false,
          on_true: [
            '1',
            0
          ],
          on_false: [
            '5',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      },
      7: {
        inputs: {
          filename: filename,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '2',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      10: {
        inputs: {
          seed: seed
        },
        class_type: 'easy seed',
        _meta: {
          title: 'EasySeed'
        }
      },
      12: {
        inputs: {
          text: '583975022290722',
          anything: [
            '10',
            0
          ]
        },
        class_type: 'easy showAnything',
        _meta: {
          title: 'Show Any'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        const inputIndex = 7 // prompt信息组件名的下标
        if (promptInfo.status.status_str === 'success') {
          const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)
          imageList.push(genOssImage(tmp[0]))
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}

export {
  cutpicture
}
